<template lang="pug">
section.territorio
    BaseHeader(
        :titulo="$t('mensagens.pssc.telaIncluirTerritorios.titulo')",
        icon='el-icon-plus',
        :btnTexto="$t('mensagens.pssc.telaIncluirTerritorios.continuar')",
        :exibeBotao='true',
        @btnHeaderClicado="modalConsolidarLote.mostrar = true",
        :desabilitaBotao='!botaoContinuarHabilitado',
        :voltarPara='true'
    )

    .view-container-base-header
        .incluir-territorio__container
            section.lista-pssc__barra-pesquisa-filtro
                .pesquisa-inteligente__content
                    .lista-pssc__barra-pesquisa-filtro__barra
                        i.el-icon-search
                        input.lista-pssc__barra-pesquisa__input(
                            v-model='payload.filtros.payload.texto',
                            type='text',
                            :placeholder="$t('mensagens.pssc.pesquisaInteligente.pesquisaInteligentePlaceholder')",
                            autocomplete='off',
                            @keyup.enter='fetchLista(0)'
                            @input='habilitaPesquisa = payload.filtros.payload.texto.length >= 3'
                        )
                        el-button.primary-button.btn-filtro(
                            icon='el-icon-search',
                            type='primary',
                            size='large',
                            @click='fetchLista(0)',
                        ) {{ $t('mensagens.pssc.pesquisaInteligente.botaoBuscar') }}
                    transition(name='el-zoom-in-top')
                        ul.pesquisa-inteligente__ul(
                            v-show='mostrarLista',
                            v-loading='loadingPesquisaInteligente'
                        )
                            .mb-2.pesquisa-inteligente__lista-vazia(
                                v-if='sugestoesBusca.length === 0'
                            ) {{ $t('mensagens.pssc.pesquisaInteligente.nenhumResultadoEncontrado') }}
                            .pesquisa-inteligente__lista(v-else)
                                .mb-2.pesquisa-inteligente__car(v-for='opcao in sugestoesBusca')
                                    .pesquisa-inteligente__categoria
                                        span(
                                            v-if='opcao.resultados.length'
                                        ) {{ internacionalizacaoCategoria(opcao.categoria) }}

                                    li.pesquisa-inteligente__item(
                                        v-for='resultado in opcao.resultados',
                                        @click='selecionarOpcao(resultado.codigo || resultado.nome)'
                                    )
                                        span() {{ resultado.codigo || resultado.nome }}

                .lista-pssc__barra-pesquisa-filtro__filtro
                    el-popover(
                        placement='bottom'
                        width='500',
                        trigger='click',
                        @show='abrirCollapse'
                    )
                        el-button.button-outline.btn-filtro(
                            icon='lyra-icon lyra-filtro',
                            name='filtro',
                            slot='reference'
                        ) {{ $t('mensagens.pssc.telaLista.botaoFiltro') }}

                        div.mb-2(style="display: flex; justify-content: space-between; align-items: center")
                            #titulo-filtro
                                | {{ $t('mensagens.pssc.telaLista.botaoFiltro') }}
                            #titulo-filtro-link(@click='fetchLista(0)')
                                | {{ $t('mensagens.pssc.telaLista.botaoAplicarFiltro') }}

                        el-collapse.lista-pssc__barra-pesquisa-filtro__filtro-popover-collapse(
                            v-model='payload.filtros.collapseAtivo',
                            accordion,
                            @change='abrirCollapse'
                        )
                            el-collapse-item(
                                :title='$t("mensagens.pssc.telaLista.filtros.localidade")',
                                name='estados'
                            )
                                section(style="display: flex; justify-content: start")
                                    div.mr-3(v-loading='!estados.length')
                                        el-select(
                                            v-model='payload.filtros.payload.estado',
                                            filterable,
                                            clearable,
                                            value-key='id',
                                            @change="buscarMunicipios(); payload.filtros.payload.municipio = null"
                                            @clear="limparFiltro('estado')",
                                            :placeholder='$t("mensagens.blocoFiltros.uteis.uf")'
                                        )
                                            el-option(
                                                v-for='(estado, index) in estados',
                                                :key='index',
                                                :label='estado.nome',
                                                :value='estado.id'
                                            ) {{ estado.nome }}
                                    div
                                        el-select(
                                            v-model='payload.filtros.payload.municipio',
                                            filterable,
                                            clearable,
                                            value-key='id',
                                            @clear="limparFiltro('municipio')",
                                            :placeholder='$t("mensagens.blocoFiltros.uteis.municipio")',
                                            :disabled='!payload.filtros.payload.estado'
                                        )
                                            el-option(
                                                v-for='(municipio, index) in municipios',
                                                :key='index',
                                                :label='municipio.nome',
                                                :value='municipio.id'
                                            ) {{ municipio.nome }}

                            el-collapse-item(
                                :title='$t("mensagens.pssc.telaIncluirTerritorios.filtros.areaHa")',
                                name='area'
                            )
                                el-checkbox-group(
                                    v-model='payload.filtros.payload.area',
                                    :max='4'
                                )
                                    el-checkbox.area__checkbox(label='ATE_50')
                                        | {{ $t('mensagens.pssc.telaIncluirTerritorios.filtros.ate50') }}
                                    el-checkbox.area__checkbox(label='ENTRE_50_A_500')
                                        | {{ $t('mensagens.pssc.telaIncluirTerritorios.filtros.de50a500') }}
                                    el-checkbox.area__checkbox(label='ENTRE_500_A_1000')
                                        | {{ $t('mensagens.pssc.telaIncluirTerritorios.filtros.de500a1000') }}
                                    el-checkbox.area__checkbox(label='ACIMA_1000')
                                        | {{ $t('mensagens.pssc.telaIncluirTerritorios.filtros.acimaDe1000') }}

            .instrucoes__container
                h3.instrucoes-incluir__label {{ $t('mensagens.pssc.telaIncluirTerritorios.listaTerritoriosElegiveis') }}
                span.instrucoes-incluir__texto {{ $t('mensagens.pssc.telaIncluirTerritorios.instrucoesSelecaoTerritorios') }}

            section.inserir-territorio-pssc__lista
                div.selecao-tabela__container
                    div.card-contagem-selecao(
                            v-if='qtdSelecionados>0'
                        )
                        div.contagem-selecao
                            span.contador-selecao {{this.qtdSelecionados}}
                                span.descricao-selecao {{this.descricaoSelecionados()}}
                        div.acao-selecao(
                            @click='selecionarRemanescentes'
                        ) {{ this.totalRemanescente }}

                .inserir-territorio-pssc__lista__tabela
                    el-table(
                        :data='payload.itens',
                        stripe,
                        height='calc(100% - 40px)',
                        @select='alterarSelecao'
                        @selection-change='mudarSelecao'
                        @select-all='selecionarTodos',
                        ref='tabelaTerritoriosPssc',
                        :stripe='false'
                        :rowClassName='rowClassName'
                        v-loading='conditions.onFetching',
                        :empty-text="$t('mensagens.pssc.telaIncluirTerritorios.tabela.listaVazia')"
                    )
                        el-table-column(
                            align='left',
                            type="selection",
                            class-name='el-checkbox__table__incluir-territorio',
                            width='42px'
                        )
                        
                        el-table-column(
                            :label='$t("mensagens.pssc.telaIncluirTerritorios.tabela.labels.territorio")',
                            align='left',
                            min-width='150px'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.territorio }}

                        el-table-column(
                            :label='$t("mensagens.pssc.telaIncluirTerritorios.tabela.labels.car")',
                            align='left',
                            min-width='150px'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.car }}

                        el-table-column(
                            :label='$t("mensagens.pssc.telaIncluirTerritorios.tabela.labels.areaHa")',
                            align='left',
                            width='120px'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.areaHa }}

                        el-table-column(
                            :label='$t("mensagens.pssc.telaIncluirTerritorios.tabela.labels.pessoa")',
                            align='left'
                        )
                            template(slot-scope='scope')
                                div(style="display: grid; grid-template-columns: 1fr 0.1fr")
                                    div
                                        div(style="line-height: 15px") {{ scope.row.pessoas[0].nome }}
                                        div(style="font-size: 13px; color: #7C7C7C") {{ scope.row.pessoas[0].documento }}
                                    el-tooltip(v-if="scope.row.pessoas.length > 1", placement='bottom', effect="light")
                                        el-tag(color="#359138", effect="dark", type="primary", size="small",
                                            style="border: none; padding-top: 2px")
                                            | + {{ scope.row.pessoas.length - 1 }}
                                        div.lista-scroll(slot="content")
                                            div(v-for="(item, index) in scope.row.pessoas" :key="index")
                                                p(v-if="index !== 0" ) {{ item.nome + ' (' + item.documento + ')' }}
     
                        el-table-column(
                            :label='$t("mensagens.pssc.telaIncluirTerritorios.tabela.labels.localidade")',
                            align='left'
                        )
                            template(slot-scope='scope')
                                div {{ scope.row.localidade.municipio }}
                                div(style="font-size: 13px; color: #7C7C7C") {{ scope.row.localidade.estado }}

                    .inserir-territorio-pssc__lista__tabela__rodape
                        div(style="display: flex; align-items: center; justify-content: space-between" v-if="payload.paginacao.total !== 0")
                            div.mr-4 {{ payload.paginacao.total }} {{ $t(`mensagens.pssc.telaIncluirTerritorios.tabela.paginacaoResultado`) }}

                            | {{ $t(`mensagens.pssc.telaIncluirTerritorios.tabela.paginacaoPorPagina`) }}
                            el-select(
                                v-model='payload.paginacao.itensPorPagina',
                                class="ml-2",
                                style='width: 70px',
                                size="mini",
                                @change="mudarTamanhoTabela()"
                            )
                                el-option(
                                    v-for='item in itensPorPagina',
                                    :key='item',
                                    :label='item',
                                    :value='item'
                                )

                        .tabela-rodape--pagination
                            el-pagination(
                                mini,
                                layout='prev, pager, next, jumper',
                                hide-on-single-page
                                :page-size='payload.paginacao.itensPorPagina',
                                :current-page.sync='payload.paginacao.pagina',
                                :total='payload.paginacao.total',
                                @current-change='proximaPagina'
                            )

    ModalConsolidarLote(
        :show='modalConsolidarLote.mostrar',
        @closeDialog='modalConsolidarLote.mostrar = false',
        @showNotificacaoSucesso='showModalNotificacaoSucesso'
        :selecionarTodos='selecionarTodosTerritorios',
        :selecao='selecaoTerritorios',
        :filtros='payload.filtros.payload'
    )

    ModalNotificacaoSucessoPssc(
        :show='modalSucessoInclusao.mostrar',
        @closeDialog='modalSucessoInclusao.mostrar = false',
        @fecharNotificacaoSucesso='fecharModalNotificacaoSucesso'
    )

</template>

<script>
import ModalConsolidarLote from '@/components/pssc/ModalConsolidarLotePssc';
import ModalNotificacaoSucessoPssc from '@/components/pssc/ModalNotificacaoSucessoPssc';
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';

import PSSCService from '@/services/PSSCService';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        ModalConsolidarLote,
        ModalNotificacaoSucessoPssc
    },
    data() {
        return {
            conditions: {
                onFetching: false,
                onSaving: false
            },
            payload: {
                filtros: {
                    payload: {
                        estado: null,
                        municipio: null,
                        area: []
                    }
                },
                itens: [],
                paginacao: {
                    direcao: null,
                    itensPorPagina: 10,
                    ordernarPor: null,
                    pagina: 0,
                    totalPaginas: 0,
                    total: 0
                }
            },
            mostrarLista: false,
            itensPorPagina: [10, 20, 50, 100],
            estados: [],
            municipios: [],
            botaoContinuarHabilitado: false,
            selecionarTodosTerritorios: false,
            selecaoTerritorios: [],
            linhasSelecionadas: [],
            qtdSelecionados: 0,
            totalRemanescente: '',
            sugestoesBusca: [],
            modalConsolidarLote: {
                mostrar: false
            },
            modalSucessoInclusao: {
                mostrar: false
            },
            loadingPesquisaInteligente: false,
            habilitaPesquisa: false
        };
    },

    async mounted() {
        await this.fetchLista(0);

        const input = document.getElementsByClassName('lista-pssc__barra-pesquisa__input')[0];
        const handleInput = this.aguardarInputPesquisaInteligente(() => {
                this.pesquisaInteligente();
        }, 1000);
        input.addEventListener('input', handleInput);

        const pesquisaInteligenteContainer = document.getElementsByClassName('pesquisa-inteligente__ul')[0];
        const handleClickOutsidePesquisaInteligente = (event) => {
            if (!pesquisaInteligenteContainer.contains(event.target)) {
                this.mostrarLista = false;
                this.sugestoesBusca = [];
            }
        };
        document.addEventListener('click', handleClickOutsidePesquisaInteligente);
    },

    methods: {
        async fetchLista(pagina) {
            this.mostrarLista = false;
            this.conditions.onFetching = true;

            const paginacao = {...this.payload.paginacao};
            paginacao.pagina = pagina;

            await PSSCService.buscarElegiveis({
                ...this.payload.filtros.payload,
                paginacao: paginacao
            })
                .then(({data}) => {
                    this.payload.itens = data.itens;

                    this.payload.paginacao.total = data.paginacao.total;
                    this.payload.paginacao.itensPorPagina = data.paginacao.itensPorPagina;
                    this.payload.paginacao.totalPaginas = data.paginacao.totalPaginas;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroSituacao')
                    });
                })
                .finally(() => {
                    this.conditions.onFetching = false;
                    const component = document.getElementsByClassName('el-pagination__jump')[0];
                    if (component) {
                        component.firstChild.textContent =
                            this.$t('mensagens.pssc.telaIncluirTerritorios.tabela.irParaPagina');
                    }

                    setTimeout(() => {
                        this.payload.itens.forEach((row, index) => {
                            const checkbox = document.querySelector(
                                `.el-table__body-wrapper tbody tr:nth-child(${index + 1}) .el-checkbox__input input`
                            );
                            if (checkbox) {
                                checkbox.id = `idTerritorio-${row.id}`;
                            }
                        });
                    }, 0);
                });
        },

        async proximaPagina(pagina) {
            await this.fetchLista(pagina - 1)
                .then(() => this.marcarSelecionados());
        },

        abrirCollapse(ref) {
            try {
                if (!this.estados.length && typeof this.estados !== 'string') {
                    this.buscarEstados();
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    'Não foi possível buscar os dados.'
                );
                throw new Error(
                    'Ação não registrada para o filtro: estados, ERRRO:' +
                    error
                );
            }
        },

        buscarEstados() {
            PSSCService.buscarLocalidadeTerritoriosElegíveis({
                'gestaoLote': false,
                'idSuperior': 1,
                'nivel': 1
            })
                .then(({data}) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarMunicipios() {
            if (this.payload.filtros.payload.estado) {
                PSSCService.buscarLocalidadeTerritoriosElegíveis({
                    'gestaoLote': false,
                    'idSuperior': this.payload.filtros.payload.estado,
                    'nivel': 2
                })
                    .then(({data}) => {
                        this.municipios = null;
                        setTimeout(() => {
                            this.municipios = data;
                        }, 500);
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os dados de municipio.'
                        );
                        throw error;
                    });
            }
        },

        alterarSelecao(_, linhaClicada) {
            if (!this.selecaoTerritorios.includes(linhaClicada.id)) {
                this.selecaoTerritorios.push(linhaClicada.id);
            } else {
                let index = this.selecaoTerritorios.indexOf(linhaClicada.id);
                this.selecaoTerritorios.splice(index, 1);
            }
            this.habilitarBotaoContinuar();
            this.contarSelecionados();
        },

        marcarSelecionados() {
            if (this.payload.itens) {
                this.payload.itens.forEach(territorio => {
                    var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                    if (this.selecionarTodosTerritorios) {
                        if (index === -1) {
                            this.$refs.tabelaTerritoriosPssc.toggleRowSelection(territorio);
                        }
                    } else {
                        if (index !== -1) {
                            this.$refs.tabelaTerritoriosPssc.toggleRowSelection(territorio);
                        }
                    }
                });
            }
        },

        mudarTamanhoTabela() {
            this.fetchLista(0)
                .then(() => this.marcarSelecionados());
        },

        habilitarBotaoContinuar() {
            if (
                (this.selecionarTodosTerritorios && this.selecaoTerritorios.length < this.payload.paginacao.total) ||
                (!this.selecionarTodosTerritorios && this.selecaoTerritorios.length !== 0)
            ) {
                this.botaoContinuarHabilitado = true;
            } else {
                this.botaoContinuarHabilitado = false;
            }
        },

        showModalNotificacaoSucesso() {
            this.modalSucessoInclusao.mostrar = true;
        },

        selecionarTodos(selecao) {
            if (this.selecionarTodosTerritorios) {
                this.payload.itens.forEach(territorio => {
                    var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                    if (index === -1) {
                        this.selecaoTerritorios.push(territorio.id);
                    }
                });
            } else {
                if (this.limparSelecao) {
                    this.selecaoTerritorios = [];
                } else {
                    if (selecao.length === 0) {
                        this.payload.itens.forEach(territorio => {
                            var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                            if (index !== -1) {
                                this.selecaoTerritorios.splice(index, 1);
                            }
                        });
                    } else {
                        selecao.forEach(territorio => {
                            var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                            if (index === -1) {
                                this.selecaoTerritorios.push(territorio.id);
                            }
                        });
                    }
                }
            }
            this.habilitarBotaoContinuar();
            this.contarSelecionados();
        },

        selecionarRemanescentes() {
            if (this.qtdSelecionados === this.payload.paginacao.total) {
                this.limparSelecao = true;
                document.getElementsByClassName('el-checkbox__table__incluir-territorio')[0].querySelector('input.el-checkbox__original').click();
            } else {
                this.limparSelecao = false;
                const checkbox = document.getElementsByClassName('el-checkbox__table__incluir-territorio');
                for (let i = 1; i < checkbox.length; i++) {
                    const inputElement = checkbox[i].querySelector('input.el-checkbox__original');
                    if (inputElement && !inputElement.checked) {
                        inputElement.click();
                    }
                }
            }

            this.selecaoTerritorios = [];
            this.selecionarTodosTerritorios = !this.limparSelecao;
            this.limparSelecao = false;
            this.contarSelecionados();
        },

        atualizarRemanescentes() {
            if (
                (this.selecionarTodosTerritorios && this.selecaoTerritorios.length === 0) ||
                (!this.selecionarTodosTerritorios && this.payload.paginacao.total === this.selecaoTerritorios.length)
            ) {
                this.totalRemanescente = this.$t('mensagens.pssc.telaIncluirTerritorios.limparSelecao');
            } else {
                var total = 0;
                if (this.selecionarTodosTerritorios) {
                    total = this.selecaoTerritorios.length;
                } else {
                    total = Number.parseInt((this.payload.paginacao.total) - (this.selecaoTerritorios.length));
                }

                if (total === 1) {
                    this.totalRemanescente = this.$t('mensagens.pssc.telaIncluirTerritorios.selecionarUmTerritorioDaLista');
                } else {
                    let texto = this.$t('mensagens.pssc.telaIncluirTerritorios.selecionarDemaisTerritoriosDaLista').split('{totalRemanescente}');
                    this.totalRemanescente = texto[0] + total + texto[1];
                }
            }
        },

        contarSelecionados() {
            if (!this.selecionarTodosTerritorios) {
                this.qtdSelecionados = this.selecaoTerritorios.length;
            } else {
                this.qtdSelecionados = parseInt(this.payload.paginacao.total - this.selecaoTerritorios.length);
            }
            this.atualizarRemanescentes();
            this.ajustarAlturaTabela();
        },

        ajustarAlturaTabela() {
            var elements = document.getElementsByClassName('inserir-territorio-pssc__lista__tabela');
            if (parseInt(this.qtdSelecionados) >= 1) {
                elements[0].style.height = 'calc(100vh - 369px)';
            } else {
                elements[0].style.height = 'calc(100vh - 317px)';
            }
        },

        descricaoSelecionados() {
            if (this.qtdSelecionados > 1) {
                return this.$t('mensagens.pssc.telaIncluirTerritorios.territoriosEstaoSelecionados');
            } else {
                return this.$t('mensagens.pssc.telaIncluirTerritorios.territorioEstaSelecionado');
            }
        },

        fecharModalNotificacaoSucesso() {
            this.selecaoTerritorios = [];
            this.qtdSelecionados = 0;
            this.selecionarTodosTerritorios = false;
            this.fetchLista(0);
            this.ajustarAlturaTabela(0);
            this.habilitarBotaoContinuar();
            this.$router.push('/pssc');
        },

        mudarSelecao(linhas) {
            this.linhasSelecionadas = linhas;
        },

        rowClassName({row}) {
            return this.linhasSelecionadas.includes(row) ? 'table-row_selected' : '';
        },

        ordenar(props) {
            this.payload.paginacao.direcao = props.order === 'ascending' ? 'ASC' : 'DESC';
            this.payload.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.payload.paginacao.ordernarPor = null;
            this.fetchLista(0);
        },

        limparFiltro(filtro) {
            this.payload.filtros.payload.municipio = null;
            if (filtro === 'estado') {
                this.payload.filtros.payload.estado = null;
                this.municipios = [];
            }
        },

        aguardarInputPesquisaInteligente(func, delay) {
            let temporizador;
            return function (...args) {
                clearTimeout(temporizador);
                temporizador = setTimeout(() => func.apply(this, args), delay);
            };
        },

        async pesquisaInteligente() {
            if (this.habilitaPesquisa) {
                this.loadingPesquisaInteligente = true;
                this.mostrarLista = true;
                await PSSCService.pesquisaInteligentePssc({
                    'texto': this.payload.filtros.payload.texto,
                    'gestaoLote': false
                })
                    .then(({data}) => {
                        if (data.cars.resultados.length === 0 && data.territorios.resultados.length === 0) {
                            this.sugestoesBusca = [];
                        } else {
                            this.sugestoesBusca = data;
                        }
                        this.loadingPesquisaInteligente = false;
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os territórios a partir do termo informado.'
                        );
                        throw error;
                    });
            } else {
                this.mostrarLista = false;
                this.sugestoesBusca = [];
            }
        },

        selecionarOpcao(chave) {
            this.payload.filtros.payload.texto = chave;
            this.fetchLista(0);
        },

        internacionalizacaoCategoria(chave) {
            if (!chave) {
                return;
            }
            let chaveMaiuscula = chave.toUpperCase();
            chaveMaiuscula = chaveMaiuscula.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            chaveMaiuscula = chaveMaiuscula.replace(/\s+/g, '-');

            return this.$t(`mensagens.pssc.pesquisaInteligente.categorias.${chaveMaiuscula}`);
        }
    }
};
</script>

<style lang="scss">
.territorio {
    height: 100%;
    width: 100%;

    .incluir-territorio__container {
        padding: 4px 4px 0 4px;
    }

    .lista-pssc__barra-pesquisa-filtro {
        display: grid;
        gap: 14px;
        grid-template-columns: calc(100% - 185px) 169px;
        height: 46px;
        margin-bottom: 20px;

        .lista-pssc__barra-pesquisa-filtro__barra {
            height: 46px;
            border-radius: 5px;
            color: var(--primary);
            background-color: var(--white);
            display: flex;
            justify-content: center;
            box-shadow: 0 1px 5px 0 var(--block-shadow);

            i.el-icon-search {
                color: var(--primary);
                font-size: 25px;
                font-weight: bold;
                display: flex;
                align-items: center;
                margin: 0 8px;
            }
            .el-button {
                width: fit-content;
                margin-right: 0px !important;
                display: flex;
                align-items: center;
                margin: 0 8px;
                .el-icon-search {
                    color: var(--white);
                    margin: 0;
                    font-size: 14px;
                }
            }
            .el-button:hover {
                color: var(--primary) !important;
                .el-icon-search {
                    color: var(--primary) ;
                }
            }
            .el-button:focus {
                color: var(--primary) !important;
                .el-icon-search {
                    color: var(--primary);
                }
            }

            .lista-pssc__barra-pesquisa__input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                border-radius: 5px;
                color: var(--primary);
            }
        }

        .lista-pssc__barra-pesquisa-filtro__filtro {
            height: 46px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: fit-content;
        }

        .btn-filtro {
            height: 46px !important;
        }

        .pesquisa-inteligente__ul {
            list-style: none;
            padding: 16px 0;
            position: relative;
            z-index: 42;
            margin-top: 16px;
            border-radius: 5px;
            background-color: var(--white);
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

            .pesquisa-inteligente__lista-vazia {
                color: #7C7C7C;
                padding-left: 41px;
            }
            .pesquisa-inteligente__lista {
                display: grid;
                grid-gap: 8px !important;

                .pesquisa-inteligente__car {
                    margin: 0 !important;
                    li {
                        padding-left: 18px;
                        margin-top: 5px;
                        cursor: pointer;
                    }
                    .pesquisa-inteligente__categoria {
                        font-weight: bold;
                        span {
                            padding: 0 16px;
                        }
                    }
                    .pesquisa-inteligente__item {
                        padding: 8px 0 7px 0;
                        margin-top: 0px !important;
                        span {
                            padding: 0 16px;
                        }
                    }
                    .pesquisa-inteligente__item:hover {
                        background-color: #DEF0B9;
                    }
                }
            }
        }

        .pesquisa-inteligente__territorio{
            margin-top: 8px;
        }
    }

    button {
        width: fit-content;
        cursor: pointer;
    }

    .instrucoes__container {
        height: fit-content;
        max-height: 70px;

        .instrucoes-incluir__label {
            font-weight: 600;
        }

        .instrucoes-incluir__texto {
            text-align: justify;
            word-break: keep-all;
            padding: 3px 0;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .coluna {
        .informacao-primaria__coluna {
            margin: 0px;
        }

        .informacao-secundaria__coluna {
            font-size: 12px;
            line-height: 12px;
            color: #98a0bc;
        }
    }

    .representante {
        display: flex;

        .representante-info {
            display: block;
            min-width: 80%;
        }

        .representante-popover {
            width: 20%;

            .popover-tag {
                color: var(--white);
                background-color: #359138;

                p {
                    padding-top: 2px;
                }
            }
        }
    }

    .el-table {
        border-radius: 5px 5px 0 0 !important;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }
    }

    .table-territorios {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);

        .table-row_selected {
            background-color: #F4FAE8 !important;
        }
    }

    .inserir-territorio-pssc__lista {
        height: calc(100vh - 317px);

        .selecao-tabela__container {
            margin: 8px 0;

            .card-contagem-selecao {
                height: 44px;
                background-color: #DEF0B9;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                .contagem-selecao {
                    display: flex;
                    height: fit-content;

                    .contador-selecao {
                        font-weight: 600;
                    }

                    .descricao-selecao {
                        font-weight: normal;
                    }
                }
                .acao-selecao {
                    height: fit-content;
                    font-weight: 500;
                    color: #4294EC;
                    cursor: pointer;
                }
            }
        }

        .inserir-territorio-pssc__lista__tabela {
            height: calc(100vh - 317px);
            background-color: var(--white);

            .el-table {
                border-radius: 5px;
                height: calc(100% - 40px);
                width: 100%;
            }

            .el-table th {
                font-weight: bold;
                font-size: 14px;
            }

            .tabela-btn {
                margin-top: 14px;
                display: flex;
                justify-content: start;
                align-items: center;
            }

            .inserir-territorio-pssc__lista__tabela__rodape {
                height: 40px;
                padding: 0 10px;
                background: var(--white);
                display: grid;
                justify-items: start;
                align-items: center;
                grid-template-columns: 1fr 1fr;

                .tabela-rodape--pagination {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    gap: 10px;

                    .pagina-desejada__input {
                        width: 50px;
                    }

                    .el-pager li.active {
                        color: var(--white);
                        font-weight: 900;
                        background: var(--primary);
                    }

                    .el-pager li {
                        padding: 0 4px;
                        background: var(--white);
                        vertical-align: top;
                        display: inline-block;
                        font-size: 13px !important;
                        min-width: 28px !important;
                        height: 28px !important;
                        line-height: 28px !important;
                        box-sizing: border-box;
                        text-align: center;
                        margin: 0;
                        border-radius: 2px;
                        color: var(--primary);
                    }

                    .el-pagination button {
                        height: 28px;
                    }
                }
            }

            .box-expande-listagem {
                display: flex;
                align-items: flex-start;
                justify-content: space-around;
                margin-top: 15px;
                margin-bottom: 15px;
                padding: 0 18px;

                .box-expande-listagem-box {
                    width: 33%;

                    .box-expande-listagem-box-texto {
                        font-weight: 600;
                        color: var(--primary);
                    }

                    .box-expande-listagem-box-value {
                        max-height: 75px;
                        overflow-y: auto;
                        font-weight: 400;
                        color: var(--primary);
                    }
                }
            }
        }
    }

    .el-dialog__body {
        padding: 5px 20px;
        color: var(--text-disabled);
        font-size: 14px;
        word-break: break-all;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }
}

.lista-scroll {
    max-height: 300px;
    overflow-y: auto;
    flex-direction: column;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}

.el-checkbox.area__checkbox{
    min-width: 15% !important;
    width: fit-content !important;
}

</style>
